// extracted by mini-css-extract-plugin
export var tagMarginFixed = "fareCancellationPolicyStep-module--tag-margin-fixed--4d06c";